import { handleActions } from 'redux-actions';
import { ENV_DEFAULT_OPTION_SUBSCRIPTION } from '../../../shared/constants/matrixOptions';
import { setStackSelection, setStackAccount, setSearchTextGlobal } from './actions';

const defaultState = {
  stackSelection: ENV_DEFAULT_OPTION_SUBSCRIPTION,
  selectedAccount: ENV_DEFAULT_OPTION_SUBSCRIPTION,
  searchTextSubscription: '',
};

const orderOperations = handleActions(
  {
    [setStackSelection]: (state, { payload }) => ({
      ...state,
      stackSelection: payload,
      isError: false,
    }),
    [setStackAccount]: (state, { payload }) => ({
      ...state,
      selectedAccount: payload,
      isError: false,
    }),
    [setSearchTextGlobal]: (state, { payload }) => ({
      ...state,
      searchTextSubscription: payload,
    }),
  },
  defaultState
);

export default orderOperations;
